'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _viewprt = require('viewprt');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyImageSetup = function LazyImageSetup(el) {
  (0, _classCallCheck3.default)(this, LazyImageSetup);

  (0, _viewprt.ElementObserver)(el, {
    onEnter: function onEnter(el) {
      new LazyImage({ el: el });
    },

    once: true
  });
};

exports.default = LazyImageSetup;

var LazyImage = function LazyImage(_ref) {
  var _this = this;

  var el = _ref.el;
  (0, _classCallCheck3.default)(this, LazyImage);

  this.el = el;
  this.smallImage = this.el.querySelector('.img-Image_Image-small');
  this.image = this.el.querySelector('.img-Image_Image[data-src]');
  this.src = this.image.dataset.src.split(', ');
  this.width = parseInt(this.el.dataset.width, 10);
  this.imageSizes = this.el.dataset.imageSizes.split(',');
  this.sourceImage = this.el.dataset.sourceImage;
  this.supportsObjectFit = 'objectFit' in document.documentElement.style;
  this.loadedClass = 'img-Image_Image-loaded';

  if (this.supportsObjectFit) {
    var dummyImage = new Image();

    dummyImage.addEventListener('load', function () {
      _this.image.classList.add(_this.loadedClass);
    });
    this.image.addEventListener('transitionend', function (evt) {
      if (evt.propertyName === 'opacity' && _this.smallImage) {
        try {
          _this.smallImage.parentNode.removeChild(_this.smallImage);
        } catch (e) {
          console.warn(e);
        }
      }
    });

    dummyImage.setAttribute('src', this.src.join(', '));
    this.image.setAttribute('src', this.src[0]);
    this.image.setAttribute('srcset', this.src.join(', '));
  } else {
    var div = document.createElement('div');
    div.className = 'img-Image_Image img-Image_Image-large img-Image_Image-noObjectFit ' + this.loadedClass;
    var imageUrl = window.devicePixelRatio >= 2 ? this.src[1] : this.src[0];
    div.style.backgroundImage = 'url(' + imageUrl + ')';
    this.image.parentNode.replaceChild(div, this.image);
  }
};